export default __webpack_public_path__ + "fa42f9762dc03788fd5753c013f1ba0f.png";